import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {useTranslation} from '@modifi/plugin-i18n'
import {Link} from '@modifi/router'
import {ButtonSecondary} from '@modifi/ui'
import {LoginButtonNavItem, LoginButtonHamburgerWrapper, LoginButtonActualItem} from './styles'

const propTypes = {
  isHamburger: PropTypes.bool,
  loginUrl: PropTypes.string,
  navWidth: PropTypes.number,
}
const defaultProps = {
  isHamburger: false,
  loginUrl: undefined,
  navWidth: null,
}

export type LoginButtonProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const LoginButton: React.FC<LoginButtonProps> = ({loginUrl, isHamburger, navWidth}) => {
  const {t} = useTranslation('janus')

  if (!loginUrl) {
    return null
  }

  if (!isHamburger) {
    return (
      <LoginButtonNavItem>
        <LoginButtonActualItem>
          <Link to={loginUrl} targetBlank>
            {t('sitemap.login')}
          </Link>
        </LoginButtonActualItem>
      </LoginButtonNavItem>
    )
  }

  return (
    <LoginButtonHamburgerWrapper navWidth={navWidth || 0}>
      <Link to={loginUrl}>
        <ButtonSecondary data-target="login" block>
          {t('sitemap.login')}
        </ButtonSecondary>
      </Link>
    </LoginButtonHamburgerWrapper>
  )
}

LoginButton.propTypes = propTypes
LoginButton.defaultProps = defaultProps

export default LoginButton
